import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Fcontact from '../components/Fcontact';
import "./Contact.css";

const Contact = () => {
    return (
        <div>
            <Container>
                <h1>Contact</h1>
                <div className="mainboader">
                    <Row>
                        <Col className="infobox" lg="5">
                            <h2>GET IN TOUCH</h2>
                            <div className="widget-container">
                                If you have any question about Eye of China or want to Source products and get quotations, please contact us.
                            </div>

                            <div className="widget-container">
                               <h4>South Africa</h4>
                               <p> <i className="fas fa-map-marker-alt"></i> 106 Likeview Drive, Muldersdrift, South Africa</p>
                               <p> <i className="fas fa-phone-square-alt"></i> +27 63 264 8040 / 0086 136 91568618</p>
                               <p><i className="fas fa-envelope"></i> info@eyeofchina.co.za</p>
                               <p><i className="fab fa-whatsapp"></i> +27 63 264 8040</p>
                            </div>

                            <div className="widget-container">
                               <h4>China</h4>
                               <p> <i className="fas fa-map-marker-alt"></i> 106 Likeview Drive, Muldersdrift, South Africa</p>
                               <p> <i className="fas fa-phone-square-alt"></i> +27 63 264 8040 / 0086 136 91568618</p>
                               <p><i className="fas fa-envelope"></i> info@eyeofchina.co.za</p>
                               <p><i className="fab fa-whatsapp"></i> +27 63 264 8040</p>
                            </div>
                       

    </Col>
                        <Col lg="7">
                            <Fcontact />
                        </Col>
                    </Row>


                </div>
            </Container>


        </div>
    );
};

export default Contact;